import {ButtonBorder, Div, ImageView, Label} from 'components';
import {Ecolors, Icons} from 'constant';
import React from 'react';
import {goBack} from 'services';

const CompChangeSuccess = (p: {content: string; onConfirm?: () => void}) => {
  return (
    <Div
      flex={1}
      alignItems="center"
      justifyContent="center"
      backgroundColor={Ecolors.transparentLoading}>
      <Div
        width={321}
        paddingHorizontal={22}
        flexDirection="column"
        alignItems="center"
        paddingBottom={24}
        backgroundColor={Ecolors.whiteColor}
        borderRadius={10}>
        <Div flexDirection="column" alignItems="center">
          <ImageView
            marginTop={41}
            widthHeight={53}
            source={Icons.success}
            resizeMode="contain"
          />
          <Label marginVertical={30}>{p.content}</Label>
        </Div>
        <ButtonBorder
          width={276}
          onPress={() => {
            goBack();
            p.onConfirm && p.onConfirm();
          }}
          height={48}
          title="alert.dong"
        />
      </Div>
    </Div>
  );
};

export default React.memo(CompChangeSuccess);
